import React, {useCallback, useState} from 'react';
import {
  View,
  Platform,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';

import HTML from 'react-native-render-html';

import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {StyleSheet} from 'react-native';

import {RNEText} from '../../components';

import {HTMLTermsAndConditions} from '../../data/terms/terms';
import {
  BUILD_NUMBER,
  MAJOR_VERSION,
  MINOR_VERSION,
} from '../../server/api/api.config';
import {width, height, totalSize} from 'react-native-dimension';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';

const TermsConditionsScreen = () => {
  const navigation = useNavigation();

  const onPrivacyPolicyClick = () => {
    navigation.navigate(NavigationKey.PRIVACY_POLICY);
  };

  const {setCanRefresh} = usePullDownRefreshContext();

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  return (
    <>
      {Platform.OS === 'web' ? (
        <View style={webStyles.mainContainer}>
          <View style={webStyles.titleContainer}>
            <RNEText
              label="Terms and Conditions"
              variant="header"
              weight="bold"
              color="accent"
            />
          </View>
          <ScrollView style={webStyles.mainWrapper}>
            <HTML
              source={{
                html: HTMLTermsAndConditions,
              }}
            />
          </ScrollView>
          <View style={webStyles.privacyContainer}>
            <TouchableOpacity
              activeOpacity={0.75}
              onPress={onPrivacyPolicyClick}>
              <RNEText
                label="Privacy Policy "
                variant="body"
                weight="bold"
                color="primary"
              />
            </TouchableOpacity>
            <RNEText label="here" variant="body" />
          </View>
          <View>
            <RNEText
              label={`House Call version ${MAJOR_VERSION}.${MINOR_VERSION}.${BUILD_NUMBER}`}
              variant="title"
              weight="bold"
              color="accent"
              align="right"
              // eslint-disable-next-line react-native/no-inline-styles
              style={{fontSize: 16}}
            />
          </View>
        </View>
      ) : (
        <>
          <SafeAreaView style={{flex: 1}}>
            <ScrollView
              onScroll={handleScroll}
              onLayout={e => {
                setScrollViewHeight(e.nativeEvent.layout.height);
              }}
              onContentSizeChange={(contentWidth, contentHeight) => {
                setContentHeight(contentHeight);
              }}>
              <View style={mobileStyles.mainContainer}>
                {/* <RNEText
                  label="Terms and Conditions"
                  variant="header"
                  weight="bold"
                  color="accent"
                  style={{fontSize: totalSize(2.8), marginLeft: -width(1.5)}}
                /> */}

                <HTML
                  baseStyle={{fontSize: totalSize(1.8)}}
                  defaultTextProps={{
                    allowFontScaling: false,
                  }}
                  source={{
                    html: HTMLTermsAndConditions,
                  }}
                />
              </View>
            </ScrollView>

            <View style={mobileStyles.privacyContainer}>
              <TouchableOpacity
                activeOpacity={0.75}
                onPress={onPrivacyPolicyClick}>
                <RNEText
                  label="Privacy Policy "
                  variant="body"
                  weight="bold"
                  color="primary"
                  style={{fontSize: totalSize(1.6)}}
                />
              </TouchableOpacity>
              <RNEText
                label="here"
                variant="body"
                style={{fontSize: totalSize(1.6)}}
              />
            </View>

            <View style={mobileStyles.versionContainer}>
              <RNEText
                label={`House Call version ${MAJOR_VERSION}.${MINOR_VERSION}.${BUILD_NUMBER}`}
                variant="title"
                weight="bold"
                color="accent"
                align="right"
                // eslint-disable-next-line react-native/no-inline-styles
                style={{fontSize: totalSize(1.5)}}
              />
            </View>
          </SafeAreaView>
        </>
      )}
    </>
  );
};

export default TermsConditionsScreen;

const webStyles = StyleSheet.create({
  mainContainer: {
    paddingTop: 140,
    paddingBottom: 32,
    paddingHorizontal: 80,
    width: '100%',
    flex: 1,
  },
  titleContainer: {
    marginBottom: 40,
  },
  mainWrapper: {
    paddingRight: 48,
  },
  privacyContainer: {
    height: 96,
    flexDirection: 'row',
    alignItems: 'center',
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingVertical: Platform.OS === 'ios' ? totalSize(2.5): totalSize(0.5),
    paddingHorizontal: width(6),
  },
  privacyContainer: {
    height: height(4),
    paddingTop: height(1),
    paddingHorizontal: width(6),
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignContent: 'center',
    justifyContent: 'flex-start',
  },
  versionContainer: {
    marginRight: width(4),
    marginBottom: height(3),
  },
});

const sharedStyles = StyleSheet.create({
  root: {
    height: '100%',
    flexDirection: 'row',
    width: '100%',
  },
  paragraphContainer: {
    paddingVertical: 40,
    width: '100%',
  },
  tncParagraph: {
    marginBottom: 24,
  },
});
